import React from 'react';
import { SectionHeading } from './SectionHeading';
import { bonos } from '../data/salesData';
export function BonosSection() {
  return <section className="border-b border-[var(--olive)]/30 py-16 sm:py-20" data-id="element-14" data-mp="185fpkg9rgzw4">
      <div className="mx-auto max-w-6xl px-4" data-id="element-15" data-mp="13cmlzvq13xlm">
        <SectionHeading eyebrow="Siempre incluidos" data-id="element-16" data-mp="13bl16zj7nwqp">
          Los 6 Bonos
        </SectionHeading>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-17" data-mp="tfqadh4u2vcu">
          {bonos.map(bono => <article key={bono.number} className="relative flex flex-col rounded-2xl border border-[var(--olive)]/40 bg-[#0d0f08] p-6 transition-colors hover:border-[var(--gold)]/50" data-id="element-18" data-mp="ogwvbk9wewak">
              <span className="font-serif-display text-4xl font-bold text-[var(--olive)]" data-id="element-19" data-mp="fgqj01pxs2cz">
                {bono.number}
              </span>
              <h3 className="mt-3 font-semibold text-[var(--cream)]" data-id="element-20" data-mp="2er05kodr1qvu">
                {bono.title}
              </h3>
              <p className="mt-2 flex-1 text-sm text-white/65" data-id="element-21" data-mp="qvec3fvide1y">
                {bono.description}
              </p>
              <div className="mt-4 flex items-center gap-3" data-id="element-22" data-mp="vu91x1rw82vk">
                <span className="text-sm text-white/40 line-through" data-id="element-23" data-mp="vsei5qscygt2">
                  {bono.price}
                </span>
                <span className="rounded-full bg-[var(--gold)] px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-black" data-id="element-24" data-mp="mtt68ehe6019">
                  Gratis
                </span>
              </div>
            </article>)}
        </div>

        <p className="mt-10 text-center text-lg font-semibold text-[var(--cream)]" data-id="element-25" data-mp="1ejp8a5q9epjw">
          Valor total bonos:{' '}
          <span className="text-white/50 line-through" data-id="element-26" data-mp="10tc0q4ha5cv3">$53.000 ARS</span>{' '}
          <span className="text-[var(--gold-light)]" data-id="element-27" data-mp="15rdtjh4icqjr">
            → Gratis con tu Super Kit
          </span>
        </p>
      </div>
    </section>;
}